import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <div className="min-h-screen grid place-items-center">
      <div className="text-center space-y-4">
        <div className="text-6xl font-bold">404</div>
        <p className="text-muted-foreground">That page does not exist.</p>
        <Button asChild>
          <Link to="/dashboard">Back to dashboard</Link>
        </Button>
      </div>
    </div>
  )
}
